import dompurify from 'dompurify';

export const sanitizeHtml = (html: string | Node): { __html: string } => {
  return { __html: dompurify.sanitize(html) };
};
